import { render } from "./AccountFormsView.vue?vue&type=template&id=0efa5eb6&scoped=true"
import script from "./AccountFormsView.vue?vue&type=script&lang=js"
export * from "./AccountFormsView.vue?vue&type=script&lang=js"

import "./AccountFormsView.vue?vue&type=style&index=0&id=0efa5eb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efa5eb6"]])

export default __exports__